import { connect } from 'react-redux';

import { getTagsSelected } from '../selectors';
import EditPanel from 'components/EditPanel/index';
import {
  handleCancelEditing,
  handleDoneEditing,
  entriesRemove,
  handleMarkAsRead,
  tagsUpdatedInSelection,
  entriesOpened
} from '../actions';

/*------------------------------------------------------------ */

const mapStateToProps = ({ data, scene }, ownProps) => {
  return {
    ...ownProps,
    tagsSelected: getTagsSelected({ data, scene }),
    tagOptions: data.tags
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleDoneEditingTags: () => {dispatch(handleDoneEditing()) },
    handleTagsUpdated: (tags) => { dispatch(tagsUpdatedInSelection(tags)) },
    handleEntriesRemove: () => { dispatch(entriesRemove()) },
    handleMarkAsRead: () => { dispatch(handleMarkAsRead(true)) },
    handleMarkAsUnread: () => { dispatch(handleMarkAsRead(false)) },
    handleDone: () => { dispatch(handleDoneEditing()) },
    handleCancel: () => { dispatch(handleCancelEditing()) },
    handleOpenExternal: (entryIds) => { dispatch(entriesOpened(entryIds, 'edit panel'))}
  }
}

const AddTagsBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPanel)
export default AddTagsBar;



// WEBPACK FOOTER //
// ./src/scenes/Main/components/EditPanelContainer.js